export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../assets/images/jobs/job-banner.jpg'),
        title: '发现. 考验. 聘用.',
        description: '',
        component: ''
      }
  ],
  applyNow: 'Apply Now',
  offer:[
    {
      icon: require('../../assets/images/jobs/job-icon-1.png'),
      title: '灵活的工作时间和地点',
      description: '你可以安排什么时候在这里工作天。 可以做家庭办公。'
    },
    {
      icon: require('../../assets/images/jobs/job-icon-2.png'),
      title: '推荐奖金',
      description: 'Maesinfo非常注重人才的挖掘，如果你能利用自己的社交网络帮我们推荐合适的工作人选，我们会向你提供丰厚的推荐奖金。'
    },
    {
      icon: require('../../assets/images/jobs/job-icon-3.png'),
      title: '工作与生活的平衡',
      description: 'Maesinfo希望每一位员工都能平衡好工作与生活，因此我们会想你提供5周的超长全薪假期，让你在忙碌的工作后可以好好放松，以最好的状态投入工作。'
    },
    {
      icon: require('../../assets/images/jobs/job-icon-4.png'),
      title: '学习与技术',
      description: 'IT行业日新月异，为了更好的迎接的时代挑战，软件工程师也需要不停的学习最新的技术。Maesinfo一直学习和运用最新的技术，我们会向你提供参加前沿项目的机会，并定期举办培训会议。'
    }
  ],
  jobs:[
    {
      title: '软件测试',
      address: '成都.中国',
      description: `
      4K-6K/成都/经验1-3年/大专以上/全日制<br/>
      工作职责：<br/>
      1.负责手机应用、网站及相关产品的测试，确保产品质量<br/>
      2.进行测试需求分析、用例设计、测试执行，制定测试计划和测试策略，编写测试报告；<br/>
      3.建议改进测试过程以提高测试效率。<br/>
      4.确保测试进度和风险评估；<br/>
      5.确保程序版本发布后网站的稳定运行；<br/>
      技能要求：<br/>
      1.有网站和移动应用软件测试经验，包括Android、iOS等移动平台测试经验；<br/>
      2.熟悉软件工程、软件测试理论和方法，熟悉相关测试程序、测试文档标准和软件工程原理；<br/>
      3.精通软件测试方法和技术，能独立开发测试计划、测试用例、测试规范，能编制标准化测试文件；<br/>
      4.热爱测试工作，具有良好的学习、沟通和协调能力，具有良好的团队合作意识；<br/>
      5.较强的逻辑思维能力，分析总结问题的能力，良好的沟通能力。
      `
    },
    {
      title: 'AI工程师',
      address: '珠海，中国',
      description: `
      12k-24k / 经验3-5年 / 硕士及以上 / 全职 <br/>
      岗位职责：<br/>
      1.从事人工智能领域前沿算法的研发，技术驱动，探索人工智能的创新应用； <br/>
      2.从具体的场景和问题出发，研发算法系统，产出解决方案； <br/>
      3.构建人工智能平台，将智能服务的能力赋予更多的产品。<br/>
      任职要求：<br/>
      1.机械工程、计算机、数理统计类专业背景，硕士以上学历，博士优先； <br/>
      2.对以下至少一个领域有深入研究或者资深的工作经验： 深度学习、自然语言处理、搜索／推荐算法、知识表示及推理、问答系统、图像识别、统计机器学习 ；<br/>
      3.熟悉Hadoop、Spark、Caffe、Tensorflow等开源社区，有实际开发经验者优先； <br/>
      4.熟悉Python 和Java； <br/>
      5.学习能力强、善于沟通、对技术创新充满激情。

     `,
      component: ''
    },
    {
      title: 'Andriod开发工程师',
      address: '成都，中国',
      description: `
      8k-15k / 经验3-5年 / 本科及以上 / 全职<br/>
      任职要求：<br/>
      1.招聘Android移动端开发软件工程师<br/>
      2.熟悉Android开发技术，熟悉客户端代码优化，熟悉使用版本管理工具；<br/>
      3.具有前端的html5、react开发经验优先；<br/>
      4.熟悉Android系统应用开发架构，熟悉系统资源分配和调度，客户端代码优化；<br/>
      5.具有3年及以上的项目开发经验，全日制本科以及相关专业毕业人员优先；<br/>
      6.具有良好的学习能力、沟通能力、团队合作精神

      `
    },
    {
      title: 'BI工程师(大数据)',
      address: '成都，中国',
      description: `
      8k-15k /经验3-5年 / 大专及以上 / 全职<br/>
      岗位职责：<br/>
      为专业公司搭建专业MIS系统，运用hadoop、ETL等工具提供大数据分析、报账、绩效考核、运营管理等服务，需要长期稳定的人员。<br/>
      任职要求：<br/>
      1.熟悉HADOOP平台，HIVE使用。<br/>
      2.熟练掌握数据库知识，SQL技术过硬，oracle技术熟练。<br/>
      3.熟悉使用DATASATE/KETTLE，COGNOS等ETL相关工具。<br/>
      4.有PARP、TABLEAU和Pentaho BI工具使用经验更佳<br/>
      5.能吃苦，踏实肯干、做事认真负责<br/>
      6.理解能力强、沟通能力良好<br/>
      7.2年以上相关工作经验
      `
    },
    {
      title: 'C/C++开发工程师',
      address: '上海，中国',
      description: `
      20k-30k / 经验3-5年 / 本科及以上 / 全职<br/>
      任职要求：<br/>
      嵌入式软件开发经验<br/>
      很好的C编程和调试技巧<br/>
      RTOS的经验将增加更多的价值<br/>
      对Linux操作系统内部结构、IPC、多线程有很好的理解。<br/>
      熟悉使用开源软件包<br/>
      操作系统：Linux / Android。精通实时多线程软件设计和开发，使用IPC，同步基元进行系统编程<br/>
      工具：使用嵌入式平台的主机-目标工具链开发和调试<br/>
      积极的工作态度（动态）和良好的沟通技巧
      `
    },
    {
      title: '初级C软件工程师',
      address: '成都.中国',
      description: `
      6K-8K/成都/1-3年/本科以上/全日制<br/>
      工作职责：<br/>
      2年以上基于Unix平台的C程序开发经验，熟悉AIX/Linux、shell和数据库。<br/>
      要求：<br/>
      2年以上相关工作经验，能提供学历证明，能提供学士学位证书及学历信网络查询。
      `
    },
    {
      title: '自然语言处理工程师（NLP）',
      address: '成都.中国',
      description: `
      10-20k/成都/3-5年经验/无限教育/全职<br/>
      工作职责：<br/>
      1.研究自然语言处理领域的前沿技术。<br/>
      2.从系统应用的角度出发，运用自然语言处理的理论和方法来解决实际问题。<br/>
      3.非结构化文本的特征挖掘、聚类分类、相似性计算、关联挖掘和语义分析。<br/>
      4.能够根据问题需求快速提出解决方案，结合相关前沿技术，快速构建演示系统。<br/>
      工作要求：<br/>
      1.精通自然语言处理领域的基本理论和方法，并有相关研究或项目经验。<br/>
      2.熟悉当前NLP领域的热点和前沿技术，对NLP有全面、系统的了解。<br/>
      3.熟悉Java语言编程，熟悉Linux工作环境，对数据结构和算法设计有深入的了解。<br/>
      5.优秀的分析和解决问题的能力，对解决具有挑战性的问题充满热情。<br/>
      6.工作勤奋，善于沟通，具有良好的团队合作精神。
      `
    },
    {
      title: 'C语言讲师',
      address: '成都，中国',
      description: `
      3k-4k / 经验1-3年 / 大专及以上 / 兼职<br/>
      任职要求：<br/>
      1.精通C语言；<br/>
      2.有丰富的C语言方面的项目经验。
      `
    },
    {
      title: '高级即时通讯工程师',
      address: '成都.中国',
      description: `
      15K-30K/成都/5-10年经验/学历/全职<br/>
      工作职责：<br/>
      1.负责即时通讯（IM）系统架构的设计、开发和优化；<br/>
      2.负责手机和个人电脑上即时通讯软件的开发。<br/>
      3.与Android、iOS和Web开发人员合作，完成与IM系统的对接。<br/>
      4.根据开发进度和任务分配，完成核心模块软件的设计、开发和编程任务。<br/>
      5.负责基于即时消息和消息推送的服务器功能开发。<br/>
      6.负责Java后台开发工作；<br/>
      任职资格：<br/><br/>
      1.学历要求，计算机软件或相关专业，5年以上Java开发经验；<br/>
      2.精通Java，扎实的编程基础，熟悉IO、多线程、并发等基本框架，熟悉缓存和分布式系统开发；<br/>
      3.熟悉TCP/IP协议、套接字和多线程开发，熟悉常用的网络编程框架，具有较高的并发性。有大批量系统开发经验；<br/>
      4.熟悉云计算相关平台和技术；<br/>
      5.良好的沟通和学习能力，团队合作精神，能适应较强的工作压力，工作积极主动，认真负责，具有较强的管理能力
      `
    },
    {
      title: 'Html5',
      address: '成都，中国',
      description: `
      10k-15k /经验3-5年 / 大专及以上 / 全职<br/>
      岗位职责：<br/>
      1. 负责公司产品手机客户端的开发,熟悉HTML5特性和各种JS框架,实现产品所需的交互效果；<br/>
      2.参与HTML5团队的建设和技术提升；<br/>
      3.负责前端开发工作，设计并优化完善前端基础服务架构；<br/>
      4.负责和公司产品部门、后端技术进行沟通；<br/>
      5.对Hybrid app 开发有一定的了解。<br/>
      任职要求：<br/>
      1.多年网页客户端脚本开发、架构设计方面的经验、至少精通一种客户端脚本框架；<br/>
      2.精通HTML5、JavaSCRIPT、CSS3、Jquery、Extjs、bootstrap，angularjs等直接编码，精通AJAX功能设计；<br/>
      3.能够高效进行切图，编写html，div，css，js文件；并对各种主流浏览器做兼容调试与修改；<br/>
      4.有自我激励和良好的团队协作能力，有能力在承担较大工作压力同时独立完成工作<br/>
      5.了解IOS,Android移动平台Web开发技术标准；<br/>
      6.了解php/python-django 等至少一种网站后端开发工具。<br/>
      7.有智能手机和平板开发经验优先考虑，有JQuery Mobile,AngularJS，Sencha Touch,iWebkit，等框架使用经验者优先。
      `
    },
    {
      title: 'ICT售前工程师',
      address: '成都，中国',
      description: `
      2k-4k /经验1-3年 / 大专及以上 / 全职<br/>
      岗位职责：<br/>
      1.负责组织项目技术方案的编写、标书的准备、讲解及用户答疑等工作。<br/>
      2.配合客户经理完成与用户的技术交流、方案宣讲、应用系统演示等<br/>
      3.配合业务等部门做好用户沟通、需求反馈、技术协调等<br/>
      4.配合市场人员完成应用系统演示、产品资料撰写等<br/>
      5.配合做好与合作伙伴厂商的技术交流。<br/>
      6.对行业、市场、用户需求、竞争对手等方面定期提出分析方案，为公司的市场方向、产品研发和软件开发等提供建议。
      `
    },
    {
      title: 'iOS开发工程师',
      address: '成都，中国',
      description: `
      8k-15k / 经验3-5年 / 本科及以上 / 全职<br/>
      岗位职责：<br/>
      1.根据业务需求，主要负责 iOS 应用程序的设计、开发工作；<br/>
      2.根据产品功能模块设计，独立完成 iOS 软件开发、编码实现各模块功能，确保开发质量；<br/>
      3.对 iOS 平台开发技术进行研究,根据开发过程中的体验对产品提出改进建议。<br/>
      任职要求：<br/>
      1.计算机相关专业学历，两年及以上iOS平台开发经验；能够熟练阅读英文文档，擅于学习新的技能；<br/>
      2.熟悉Objective-c语言开发，熟悉CocoaTouch框架和iOS SDK底层实现机制，熟练使用XCode、InterfaceBuilder、Instruments等开发工具；<br/>
      3.具有丰富的im、socket开发经验（即时通讯）；<br/>
      4.学习过java方面的技术；<br/>
      5.具有iPhone，ipad 成功案例者开发经验者优先；<br/>
      6.可以接受加班。
      `
    },
    {
      title: 'java开发主管',
      address: '成都，中国',
      description: `
      12k-16k /经验3-5年 / 本科及以上 / 全职<br/>
      岗位职责：<br/>
      1.负责带领6-8人小组进行开发和测试工作；<br/>
      2.数据库设计、面向对象设计、面向结构设计；<br/>
      3.根据设计文档完成软件的开发工作；<br/>
      4.负责编写软件更改说明、功能特性说明等开发文档；<br/>
      5.负责组织或配合项目、产品的测试工作等。<br/>
      任职要求：<br/>
      1.计算机相关专业本科以上学历；<br/>
      2.至少5年以上软件开发工作经验，3年以上J2EE实际项目经验，参与过至少2个J2EE大中型项目，有开发B/S结构软件的成功经历（要求有成功案例）；<br/>
      3.熟练掌握Java，精通J2EE技术及原理，熟练使用Java、HTML、Java Script、JSP、XML ；<br/>
      4.至少具备Struts、Spring、Hibernate、Ibatis中两种开发经验，熟悉MVC编程模式；<br/>
      5.熟悉Oracle，Sql Server等大型关系数据库，有一定的数据库设计经验，能够指导数据库程序的开发及测试工作；<br/>
      6.熟悉weblogic，tomcat等主流WEB服务器，有一定的使用经验；<br/>
      7.具有面向对象分析、设计、开发能力（OOA、OOD、OOP），掌握UML建模技能，能够使用PowrDesigner等建模工具；<br/>
      8.具有较强的逻辑分析能力，较强的责任心和团队精神，较好的质量意识、文档编写能力；<br/>
      9.年龄30岁左右为佳，有金融领域业务开发经验者优先。
      `
    },
    {
      title: 'PHP',
      address: '成都.中国',
      description: `
      8K-13K/成都/经验3-5年/大专以上/全日制<br/>
      工作职责：<br/>
      1.负责电子商务项目应用和功能模块的设计和程序开发、单元测试和文档编写。<br/>
      2.使用PHP语言开发高性能数据和应用服务；<br/>
      3.承担或参与项目需求分析、设计和实施；<br/>
      4.识别开发中的问题，积极参与产品、功能和技术架构的改进。<br/>
      5.根据产品要求完成电子商务平台系统/模块的技术设计和编码实现。<br/>
      工作要求：<br/>
      1.熟悉互联网相关技术，3年以上项目开发经验。<br/>
      2.精通PHP编程，有开发大型Web应用程序的经验。<br/>
      3.熟悉PHP缓存技术、查询优化和存储优化经验。<br/>
      4.精通网页前端技术，如HTML、Ajax、DIV CSS、javascript、jquery等。<br/>
      5.精通SQL语法，熟悉MySQL数据库，熟悉常用的数据库优化策略。<br/>
      6.熟悉基于MVC模式的程序开发，有OOP编码习惯。<br/>
      7.至少熟悉一个框架开发，如thinkhp和yii。<br/>
      8.对高并发性和高负载体系结构有很好的理解。<br/>
      9.全面了解互联网技术，能够独立处理大量访问网站的设计和开发。<br/>
      10.具有高性能业务、分布式和缓存技术方面的经验。<br/>
      11.能够用英语读写电子邮件<br/>
      12.最好熟悉编码器点火器框架。
      `
    },
    {
      title: '.NET',
      address: '成都.中国',
      description: `
      6K-10K/成都/经验1-3年/大专以上/全日制<br/>
      工作描述：<br/>
      1.计算机相关专业<br/>
      2.熟悉.NET相关技术，精通C语言，精通ASP，.NET MVC<br/>
      3.熟悉网络技术，精通HTML、CSS、javascript<br/>
      4.熟悉Oracle、SQL Server等主流数据库开发<br/>
      5.2年以上开发经验，至少参与过一个完整项目的研发<br/>
      6.了解软件工程，良好的团队合作能力，有电子商务经验者优先。
      `
    },
    {
      title: '项目经理',
      address: '成都.中国',
      description: `
      10-18K/成都/3-5年工作经验/本科以上/全日制<br/>
      工作职责：<br/>
      1.按照公司的项目管理规范，负责项目的整体研究、开发和实施、项目生命周期管理；<br/>
      2.了解项目的整体需求并与客户保持联系。及时反馈周期结果，并根据需求方提出的需求进行必要的变更。<br/>
      3.根据项目规范进行需求分析和详细设计和模块实施；<br/>
      制定项目开发计划文件，量化任务，并分配给适当的人员；<br/>
      5.制定项目沟通和报告计划，指导客户确定项目范围；<br/>
      工作要求：<br/>
      1.计算机、软件工程等相关专业，本科以上学历，三年以上工作经验，两年以上项目管理经验；<br/>
      2.精通Oracle数据库或其他主流数据库，能根据项目情况进行数据库调整；<br/>
      3.精通前端设计工具，如jQuery，XML，JSON，精通Java语言，精通Eclipse；<br/>
      4.具有良好的项目策划、需求控制、进度控制、风险管理能力，承担项目需求分析、策划、设计和文件转换工作；<br/>
      5.良好的口头和书面沟通能力，能够与客户进行多层次的沟通；<br/>
      6.熟悉项目管理理论，具有丰富的项目范围、时间、人员、成本、质量管理经验，具有良好的管理、组织、沟通、协调、合作能力；<br/>
      7.具有较强的文件编写能力，能根据项目要求独立编制标准化开发过程文件；<br/>
      8.熟悉软件开发生命周期和管理，严格遵守标准化的软件开发流程，有责任心和团队精神，主动负责。
      `
    },
    {
      title: 'Oracle工程师',
      address: '成都.中国',
      description: `
      5000-7000元/月成都/经验不限/本科<br/>
      工作信息<br/>
      1.编写存储过程和触发器<br/>
      2.Unix下的Oracle操作<br/>
      3.Oracle开发的基本要求：导入和导出数据，shell脚本<br/>
      4.最少的PL、SQL开发（基础）知识<br/>
      5.良好的外语读写能力
      `
    },
    {
      title: '.NET中级和高级软件工程师',
      address: '成都.中国',
      description: `
      10-15k/成都/经验5-10年/本科以上/全日制<br/>
      工作描述：<br/>
      第一：属于项目分配<br/>
      二：岗位描述：<br/>
      1.负责软件设计开发、测试、调试、系统维护；<br/>
      2.熟悉c、css、javascript、html5、jquery、winform、web等开发技术；<br/>
      3.熟悉sql2008r2;<br/>
      4.熟悉MVC、ANGROLL JS、HTML <br/>
      5.VB、C语言开发经验者优先。`
    },
    {
      title: '网络安全研发经理',
      address: '成都.中国',
      description: `
      13K-26K/成都/5-10年经验/学历/全职<br/>
      工作职责<br/>
      1.参与软件项目的设计和开发，包括需求分析、系统设计、编码和单元测试。<br/>
      2.能够独立完成业务设计及相关技术实施；<br/>
      3.完成系统的维护，包括功能改进、系统优化和技术支持；<br/>
      4.积极考虑业务需求、系统状态和问题，计划和实施系统开发。<br/>
      5.参与项目关键、难点模块的研发，根据业务特点提供整体业务导向优化方案。<br/>
      6.负责移动和物联网安全、规划、信息安全服务项目的开发和管理；<br/>
      7.能够主动关注国内外最新的安全攻击和防御技术，能够在自己擅长和感兴趣的领域进行深入的研究和研究。<br/>
      8.对网络安全、服务器安全、客户端安全、移动安全、无线安全、物联网安全等几个方面有一定的了解和研究；<br/>
      9.协助管理网络入侵检测引擎和产品开发过程<br/>
      工作要求：<br/>
      1.良好的英语听、说、读、写能力，4年以上Java开发经验，丰富的项目经验，独立或领导完成至少2个项目，具有丰富的项目经验（尤其是网络安全设计）<br/>
      2.优秀的数据库设计和优化能力，至少精通常用关系型数据库，精通甲骨文数据库开发是优先考虑的；<br/>
      3.熟悉JavaEE相关技术和框架（包括Java语言、多线程、施普灵河、Hibernate、iBATS、缓存、消息传递、工作流、Struts 2等）。<br/>
      4.精通Linux、shell和python<br/>
      5.学习能力强，逻辑思维能力强，沟通能力强，时间和过程意识强，能快速融入团队；<br/>
      6.有网络安全工作经验者优先；<br/>
      7.国家信息系统项目经理和PMP认证者优先。
      `
    },
    {
      title: 'Python 工程师',
      address: '成都.中国',
      description: `
      8K-15K/成都/经验1-3年/大专以上/全日制<br/>
      工作职责：<br/>
      1.基于django的云计算产品的功能设计、开发和实现；<br/>
      2.云计算、django等前沿技术研究和新技术框架研究<br/>
      工作要求：<br/>
      1.计算机及相关专业本科以上学历；<br/>
      2.精通python语言，熟悉django、tornado、web.py等web框架。<br/>
      3.熟悉HTML/HTML5，CSS，javascript，jquery，至少一个web框架<br/>
      4.熟练使用Linux系统，对算法、数据结构和后台开发有很强的理解力（C/C/PHP/Java等）。<br/>
      5.对云计算有很强的理解，愿意在云计算领域进一步学习和学习。<br/>
      6.有较强的进取心，良好的学习能力，良好的沟通表达能力，思维清晰，较强的实践能力和逻辑分析能力。<br/>
      7.热爱工作和生活<br/>
      8.首选以下条件：<br/>
      9.对开源技术、参与或向开发人员提交bug和补丁的强烈兴趣和爱好
      `
    },
    {
      title: '大数据软件工程师',
      address: '成都.中国',
      description: `
      8K-10K/成都/经验1-3年/本科以上/全日制<br/>
      工作描述：<br/>
      1.掌握软件工程及相关金融业务的知识，熟练运用HDFS/MR/HBase/Hive/Spark等主流大数据技术，能独立完成HBase/Hive/Spark/Kafka的开发。<br/>
      2.掌握数据库、软件和银行业务知识，精通Java和SQL。
      `
    },
    {
      title: '用户界面设计师',
      address: '成都.中国',
      description: `
      7-10k/成都/经验1-3年/大专以上/全日制<br/>
      工作职责<br/>
      1.负责公司外部设计、修订、更新；<br/>
      2.负责公司产品界面的设计、编辑和美化。<br/>
      3.对公司促销品进行艺术设计。<br/>
      4.负责与开发商合作完成其管辖范围内网站等首页的设计和编辑；<br/>
      5.其他与艺术设计有关的工作。<br/>
      技术技能<br/>
      1.美术、平面设计或相关专业，大专以上学历；<br/>
      2.两年以上网页设计和平面设计经验；<br/>
      3.具有扎实的艺术背景，良好的创造性思维和理解能力，能及时把握客户需求；<br/>
      4.精通photoshop dreamweaver等设计软件，对图像渲染和视觉效果有很好的理解；<br/>
      5.善于与人沟通，具有良好的团队精神和高度的责任心，能承受压力，有创新精神，保证工作质量。
      `
    },
    {
      title: '高级网络开发工程师',
      address: '成都.中国',
      description: `
      10-15k/成都/3-5年经验/学历/全职<br/>
      工作职责：<br/>
      岗位要求：负责企业网络应用系统的开发与维护！<br/>
      经验要求：6年以上相关经验<br/>
      技能要求：<br/>
      良好的技术能力：JavaJavaEE JSP-Spring框架JavaScript PL/SQL<br/>
      申请前应牢记的事项：<br/>
      1.需要具备Spring引导开发经验，熟悉Spring引导相关的应用程序开发设置和部署以及主流的opm框架<br/>
      2.在Resetful Web服务开发方面的经验以及在REST风格API设计和框架方面的经验<br/>
      3.分布式系统或微服务架构和开发经验
      云或Dobbo框架配置和开发服务（微服务方向）
      良好的英语阅读和邮件处理能力，良好的英语口语能力
      优秀的分析问题解决和概念分析推理能力
      能够在压力下工作以满足最后期限
      独立工作能力强，团队精神强
      能够遵守代码规则和程序！
      `
    }
  ]

}
